interface Scripts {
    name: string;
    src: string;
}
export const ScriptStore: Scripts[] = [
    {name: 'tcom', src: './assets/scripts/webchat_v3.js'},
    {name: 'chatbot', src: './assets/scripts/webchat.js'},
    {name: 'minibot', src: './assets/scripts/mini-chat.js'}
];
